(function ($) {
  /**
   * スライダー
   */
  function carouselSwiper() {
    const myOptions = {
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      centeredSlides: true,
      slidesPerView: 'auto',
    }

    const mainSlider = new Swiper('.js-gallery-carousel', myOptions);
  }
  

  /*
  * スクロールアニメーション
  */
  const delta = $(window).height() / 1.6;
  function scrollEffect() {
    $('.js-effect').each(function (i) {
      const elemPosition = $(this).offset().top;
      const scrollTop = $(window).scrollTop();
      if (scrollTop > elemPosition - delta) {
        $(this).addClass('is-visible');
      } else {
        $(this).removeClass('is-visible');
      }
    });
  }

  
  /**
   * ready
   */
  $(function() {
    carouselSwiper();
  });


  /**
   * scroll
   */
  $(window).scroll(() => {
    scrollEffect();
  });


  /**
   * load
   */
  window.addEventListener('DOMContentLoaded', () => {
    scrollEffect();
  });
})(window.jQuery);
